import React from "react";

export const Architecture: React.FC = () => {
  return <div>Hello Architecture!</div>;
};
